import { useEffect, useState } from "react";

export const DEFAULT_MAP_POSITION = [25.23293, 55.30577];
export const useGeoMapModal = ({ open, lat, lng, defaultPosition }) => {
  const [markerPosition, setMarkerPosition] = useState([lat ?? defaultPosition[0], lng ?? defaultPosition[1]]);
  const [showMap, setShowMap] = useState(false);
  const [smallMap, setSmallMap] = useState(null);
  const [expandedMap, setExpandedMap] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [mapRefreshKey, setMapRefreshKey] = useState(0);
  const [expandedMapKey, setExpandedMapKey] = useState(0);

  useEffect(() => {
    if (open) {
      setTimeout(() => setShowMap(true), 50);
    } else {
      setShowMap(false);
      setSmallMap(null);
    }
  }, [open]);

  const updateMarkerPosition = ([lat, lng], form) => {
    form.setFieldsValue({
      latitude: lat.toFixed(6),
      longitude: lng.toFixed(6),
    });
    setMarkerPosition([lat, lng]);
  };

  const openExpandedMap = () => {
    setExpanded(true);
    setExpandedMapKey(k => k + 1);
  };

  const closeExpandedMap = () => {
    setExpanded(false);
    setExpandedMap(null);
    setMapRefreshKey(k => k + 1);
  };

  return {
    markerPosition,
    showMap,
    smallMap,
    expandedMap,
    expanded,
    mapRefreshKey,
    expandedMapKey,
    setSmallMap,
    setExpandedMap,
    updateMarkerPosition,
    openExpandedMap,
    closeExpandedMap,
  };
};
